import React,{Fragment} from 'react';
import {reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Button from '@mui/material/Button';
import logo from '../assets/images/logo.png';
import '../css/LoginForm.css';

// import {history} from './../routers/Router';

//login form component

class LoginForm extends React.Component{
constructor(props){
  super(props);
  this.state ={
    loginError: '',
    invalidCredentials: false,
    inactiveUser: false,
    username: '',
    password: '',
    sessionTimeout: false
  }
}
  onSubmit = (formProps) => {
    formProps = {...formProps,
      username: this.state.username,
      password: this.state.password
    };  
      this.props.signin(formProps, (data) => {
        if(data === 'inactiveUser'){
          this.setState({
            inactiveUser: true
          },()=>{
            setTimeout(()=>{
              this.setState({
                inactiveUser: false
              })
            },3000)
          })
        } else if(data === "invalidLogin"){
          this.setState({
            invalidCredentials: true
          },()=>{
            setTimeout(()=>{
              this.setState({
                invalidCredentials: false
              })
            },3000)
          })
        }else{
            window.location.href ='/dashboard';
        }
    });
  };

componentWillMount(){
  let tokenStored = localStorage.getItem('token');
  if(tokenStored!==null){
    window.location.href ='/dashboard';
  }
}

componentDidMount(){
  if(window.location.pathname==='/session-timeout'){
    this.setState({
      sessionTimeout: true
    },()=>{
      setTimeout(()=>{
        this.setState({
          sessionTimeout: false
        })
      },5000)
    })
  }
}
  render(){
    const {handleSubmit } = this.props;
    return (
      <Fragment>
        <div className="loginForm" style={{backgroundColor: 'white'}}>
          <div className="loginUnder ">
          <form onSubmit={handleSubmit(this.onSubmit)}>
                <img src={logo} style={{width: "100%"}}/>
                <div className="text-muted my-2 text-center">Welcome! Please login to your account</div>
                {this.state.invalidCredentials ? <div class="alert alert-danger text-center" role="alert">Invalid credentials</div> : null}
                {this.state.inactiveUser ? <div class="alert alert-danger text-center" role="alert">User is not active</div> : null}
                {this.state.sessionTimeout ? <div class="alert alert-danger text-center" role="alert">Session Timeout</div> : null}
                <div className="group">
                 <input 
                    type="text"
                    name="username"
                    component="input"
                    onChange={(e)=>{this.setState({username: e.target.value})}}    
                    style={{backgroundColor: 'transparent'}}                                 
                   required/>
                 <span className="highlight"></span>
                 <span className="bar"></span>
                 <label>Username</label>              
              </div> 
              <div className="group">
                 <input 
                    type="password"
                    name="password"
                    style={{backgroundColor: 'transparent'}}     
                    onChange={(e)=>{this.setState({password: e.target.value})}}                            
                   required/>
                 <span className="highlight"></span>
                 <span className="bar"></span>
                 <label>Password</label>              
              </div> 
                <div className="mt-5 btn btn-block">
                    <Button className="myButton"  type="submit" fullWidth={true} style={{backgroundColor: '#00b0a9', color: 'white'}}>
                        Log In
                    </Button>
                </div>
            </form>
          </div>
        </div>
        {/* <div className="tnc">Terms of Use. Privacy Policy.</div> */}
        </Fragment>
    )
}
}

function mapStateToProps(state){
  return {errorMessage: state.auth.errorMessage}
}

export default compose(
  connect(mapStateToProps, actions),
  reduxForm({form: 'signin'}),
)(LoginForm);
